import { render, staticRenderFns } from "./Dokumentenliste.vue?vue&type=template&id=25c80930"
import script from "./Dokumentenliste.vue?vue&type=script&lang=js"
export * from "./Dokumentenliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports